<template>
  <div class="tip-content">
    <h4>{{ $t('主力1') }}</h4>
    <p class="explain">{{ $t('主力由特大单和大单构成，关注主力的大单数据和资金流向能够更准备地了解行情趋势。') }}</p>
    <h4>{{ $t('委托单') }}</h4>
    <p class="explain">{{ $t('满足委托量、委托金额其中任何一个条件就认为是特大单、大单、中单、小单。') }}</p>
    <h4>{{ $t('判断标准：') }}</h4>
    <table class="explain-table">
      <tr>
        <th></th>
        <th>{{ $t('委托量') }}</th>
        <th>{{ $t('委托金额') }}</th>
      </tr>
      <tr>
        <td>{{ $t('特大单') }}</td>
        <td>{{ $t('20万股以上') }}</td>
        <td>{{ $t('100万元以上') }}</td>
      </tr>
      <tr>
        <td>{{ $t('大单') }}</td>
        <td>{{ $t('6万股') }}-20万股</td>
        <td>{{ $t('30万元') }}-100万元</td>
      </tr>
      <tr>
        <td>{{ $t('中单') }}</td>
        <td>{{ $t('1万股') }}-6万股</td>
        <td>{{ $t('5万元') }}-30万元</td>
      </tr>
      <tr>
        <td>{{ $t('小单') }}</td>
        <td>{{ $t('1万股及以下') }}</td>
        <td>{{ $t('5万元及以下') }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.tip-content {
  text-align: left;
  .explain {
    margin-bottom: 20px;
  }
  .explain-table {
    width: 100%;
    border-width: 1px;
    border-style: solid;
    border-collapse: collapse;
    text-align: center;
    th,
    td {
      border-width: 1px;
      border-style: solid;
      padding: 10px 0;
    }
  }
}
</style>
